import { Outlet } from "react-router-dom";

const TemplatePage = () => {
    return (
        <Outlet />
    );
};

export default TemplatePage;
